// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__cSmGn","main":"Layout_main__ggNtc"};